/**
 * i18n Configuration
 * Supports English (en), French (fr), and Arabic (ar) with browser language detection.
 * Arabic activates RTL layout direction.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';

/** Languages whose script direction is right-to-left. */
export const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];

/** Returns true when the given language code is an RTL language. */
export const isRTL = (languageCode: string): boolean =>
  RTL_LANGUAGES.some((rtl) => languageCode.startsWith(rtl));

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'ar'],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'iris_language',
    },
  });

export default i18n;
